import React from "react";
import Link from "@/components/Link";
import RssReaderCardStat from "./RssReaderCardStat";
import cn from "classnames";

export type RssReaderCardType = {
  title: string;
  link: string;
  tag?: string;
  tagLink?: string;
  views?: number;
  replies?: number;
  latestReply?: Date;
};

export type RssReaderCardProps = RssReaderCardType;

const RssReaderCard: React.FC<RssReaderCardProps> = ({ ...card }) => (
  <div
    className={cn(
      "border-swdc-cool-gray-400 bg-background-highlight mt-6 block rounded-lg border-2 border-solid p-4",
    )}
  >
    <div className="flex flex-col gap-6 md:flex-row md:gap-20">
      <div className="min-w-0 flex-1">
        <Link
          href={card.link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-subhead-xs sm:text-subhead-s text-link active:text-link-pressed block font-bold hover:underline"
        >
          {card.title}
        </Link>
        {card.tag && card.tagLink && (
          <Link
            href={card.tagLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-swdc-silver-200 rounded-corner-subtle text-link-xs text-swdc-gray-400 active:bg-swdc-silver-300 mt-3 inline-block p-2 hover:underline"
          >
            {card.tag}
          </Link>
        )}
      </div>
      <div className="flex flex-wrap gap-8">
        <RssReaderCardStat
          label="Views"
          value={card.views?.toLocaleString() || "0"}
        />
        <RssReaderCardStat
          label="Replies"
          value={card.replies?.toLocaleString() || "0"}
        />
        <RssReaderCardStat
          label="Latest reply"
          value={card.latestReply?.toLocaleDateString() || "-"}
        />
      </div>
    </div>
  </div>
);

export default RssReaderCard;
